import BigNumber from 'bignumber.js'
import multiPoolConfig from 'config/constants/multiPool'
import multiPoolABI from 'config/abi/multiPool.json'
import erc20ABI from 'config/abi/erc20.json'
import multicall from 'utils/multicall'
import { getAddress, getDmdAddress } from 'utils/addressHelpers'

export const fetchMultiPoolAllowance = async (account) => {
  const calls = [{
    address: getDmdAddress(),
    name: 'allowance',
    params: [account, getAddress(multiPoolConfig.contractAddress)],
  }]
  const [allowance] = await multicall(erc20ABI, calls)

  return new BigNumber(allowance[0]._hex)
}

export const fetchUserStakedBalance = async (account) => {
  const calls = [{
    address: getAddress(multiPoolConfig.contractAddress),
    name: 'balanceOf',
    params: [account],
  }]
  const [balance] = await multicall(multiPoolABI, calls)

  return new BigNumber(balance[0]._hex)
}

export const fetchUserEarnedMultiPool = async (account) => {
  const calls = multiPoolConfig.earningTokens.map((token) => {
    return {
      address: getAddress(multiPoolConfig.contractAddress),
      name: 'earned',
      params: [account, getAddress(token.address)],
    }
  })
  const earnsFC = await multicall(multiPoolABI, calls)

  return earnsFC.map(earnedFC => new BigNumber(earnedFC[0]._hex))
}
